if( undefined == $ ) $ = jQuery;

$(document).ready(() => {
	// change img src for all img from dev to prod
	if (location.href.indexOf('dev.adjust.be') > -1) {
		const imgList = document.querySelectorAll('img, picture source');

		for (let i = 0; i < imgList.length; i++) {
			const src = (imgList[i].src || imgList[i].srcset).replace(/https?\:\/\/[a-z.]*adjust.be/, 'https://dev.spirou.com');

			if (imgList[i].src) imgList[i].src = src;
			else imgList[i].srcset = 'https://dev.spirou.com' + src;
		}
	}

	// Add Edit button
	
	$('.toolbar-icon-edit').click(function(){
		window.location.href = '/' + drupalSettings.path.currentPath + '/edit?destination=/' + drupalSettings.path.currentPath;

	});
	
	$('div[data-autoclose]').each(function(){
		var el = this;
		var timing = $(this).data('autoclose');
		let timer;

		if(timing) {
			timer = setTimeout(function(){
				$(el).fadeOut(function(){
					$(el).remove();
				});
			}, parseFloat(timing) * 1000);
		}

		$(el).on('click', function () {
			clearTimeout(timer);

			$(el).off('click');
			$(el).fadeOut(function(){ $(el).remove() });
		});
	});
	
	$('.modal .close').click(function(){
    	$(this).parents('.modal').fadeOut(function(){
            $(this).find('.spinner').show();    	
            $(this).find('.useful-datas').hide();    	
            $(this).find('.message').hide();    	
    	});    	
	});

	/* Verify if it's IE */
		function isIE() {
			var ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object
			var msie = ua.indexOf('MSIE '); // IE 10 or older
			var trident = ua.indexOf('Trident/'); //IE 11

			return (msie > 0 || trident > 0);
		}

	/* Fancybox default override */
		if ($.fancybox) {
			$('[data-fancybox], .actupopup').fancybox({
				loop: true,
				infobar: false,
				buttons: ['close']
			});

			$('a.fancy').fancybox({
				loop: false,
				infobar: false,
				buttons: ['close']
			});

			$('[data-fancybox="article-gallery"]').fancybox({
				loop: true,
				infobar: false,
				thumbs: {
					autoStart: true,
					axis: 'x'
				},
				buttons: ['thumbs', 'close']
			})
		}

	/* Owl Carousel boot */
		const owls = $('.owl-carousel');

		owls.each(function (i, owl) {
			let settings = {
				loop: true,
				margin: 30,
				smartSpeed: 500,
				dots: false,
				responsive: {
					0: { items: 1 },
					800: { items: 2 },
					1280: { items: 4 }
				}
			};

			if (true) { // add conditions according to specific cases
				// check below for an example
				// if too much conditions, make this a switch condition
			}

			if ($(owl).parents('section').hasClass('journal-v2')) {
				settings = {
					loop: false,
					margin: 30,
					smartSpeed: 500,
					dots: false,
					responsive: {
						0: { items: 1.25, center: true, startPosition: 1, margin: 15 },
						640: { items: 1.75, center: true, startPosition: 1 },
						720: { items: 2, center: true, startPosition: 1 },
						1024: { items: 4 }
					}
				}
			}

			if ($(owl).parents('section').hasClass('community')) {
				settings.responsive = {
					0: { items: 1.25, center: true, margin: 15 },
					420: { items: 1.5, center: true },
					640: { items: 2, center: true },
					1280: { items: 3, center: true }
				}
			}

			$(owl).owlCarousel(settings);

			$(owl).parents('section').find('.prev').on('click', function (e) {
				e.preventDefault();
				$(owl).trigger('prev.owl.carousel');
			});
			$(owl).parents('section').find('.next').on('click', function (e) {
				e.preventDefault();
				$(owl).trigger('next.owl.carousel');
			});
		});



	let _podcasts = {hashes:{}, currentHash: false};


	/* Header and burger */
		$('html').on('click', 'nav .account--link .logged a', function (e) {
			e.preventDefault();

			const $el = $(this).parents('.account--link').find('.account--content');

			if ($el.css('height') == '0px') {
				$el.css('height', $el.find('ul').css('height'));
			} else {
				$el.css('height', '0px');
			}

			return;
		});

		$('.nav-mobile .menu-toggle').click(function (e) {
			e.preventDefault();

			$(this).parent().toggleClass('opened');
		});
		$('.nav-mobile .menu-bg').click(function () {
			$('.nav-mobile .menu-toggle').click();
		});

	/* Slider management */
		const timing = 8000;
		const sliders = $('.slider-parent');

		const sliderManager = {};

		function sliderLauncher (parent) {
			return setInterval(() => {
				const actives = $(parent).find('[data-slider-name] li.active');

				actives.each(function () {
					if ($(this).is(':last-child')) {
						$(this).siblings().first().addClass('active');
					} else {
						$(this).next().addClass('active');
					}

					$(this).removeClass('active');
				});
			}, timing);
		}

		/* Object containing all sliders */
		sliders.each(function () {
			const slider = $(this);
			const name = slider.data('slider-name');
			const autoplay = !!slider.data('slider-autoplay');

			sliderManager[name] = {
				parent: slider,
				autoplay: autoplay,
				interval: autoplay ? sliderLauncher(slider) : undefined,
				pause: false
			}
		});

		/* Default setup */
		sliders.each(function () {
			$(this).find('i.completed').css('animation-duration', timing/1000 + 's')
		});

		/* Managing events around each slider */
		sliders.each(function () {
			const slider = $(this);
			const sliderName = slider.data('slider-name');
			/* Pagination click */
			slider.find('.slider-pagination a').click(function (e) {
				e.preventDefault();

				$('html, body').animate({
					scrollTop: slider.find('.slider-images').offset().top
				}, 500); // Scroll to matching slider

				const parentLi = $(this).parent();
				if (parentLi.hasClass('active')) return false;

				if (sliderManager[sliderName].autoplay) {
					clearInterval(sliderManager[sliderName].interval);
				}

				const actives = slider.find('[data-slider-name] li.active');

				actives.each(function () {
					$($(this).parents('ul').find('li')[parentLi.index()]).addClass('active');

					$(this).removeClass('active');
				});

				if (sliderManager[sliderName].autoplay) {
					sliderManager[sliderName].interval = sliderLauncher(slider);
				}

				return false;
			});

			$(this).find('.slider-arrows a').click(function (e) {
				e.preventDefault();

				/* Retrieve anything from the slider environment (be it image etc) */
				const actives = slider.find('[data-slider-name] li.active');
				const page = $(actives[0]);
				const activeIndex = page.index();

				if (sliderManager[sliderName].autoplay) {
					clearInterval(sliderManager[sliderName].interval);
				}

				const toNext = $(this).hasClass('next');

				actives.each(function () {
					let newActive;

					switch (true) {
						case (toNext && $(this).is(':last-child')) :
							newActive = $(this).siblings().first(); break;
						case (toNext) :
							newActive = $(this).next(); break;

						case (/* !toNext && */ $(this).is(':first-child')) :
							newActive = $(this).siblings().last(); break;
						default : /* !toNext */
							newActive = $(this).prev(); break;
					}

					$(newActive).addClass('active');
					$(this).removeClass('active');
				});

				if (sliderManager[sliderName].autoplay) {
					sliderManager[sliderName].interval = sliderLauncher(slider);
				}
			});
		});


	/* Forms */
		/* Input blur management */
			$('form').find('input:not([type="checkbox"]):not([type="radio"]), textarea').focus(function () {
					$(this).parent().addClass('filled');
			});
			$('form').find('input:not([type="checkbox"]):not([type="radio"]), textarea').blur(function () {
				if (this.value.length > 0) {
					$(this).parent().addClass('filled');
				} else {
					$(this).parent().removeClass('filled');
				}
			});


	/* Comments */
		$('.comments .buttons a').click(function (e) {
			if (this.href.indexOf('/login') > -1) return;

			e.preventDefault();

			switch (true) {
				case ($(this).hasClass('comment--write')) :
					$('.comments form').slideDown(500);
					$('.comment--read').fadeOut(500);
					setTimeout(() => {
						$('html, body').animate({
							scrollTop: $(this).offset().top - 300
						}, 500, function () {
							$('.comments form textarea').focus();
						});
					}, 150);
					// No break;
				default :
					$('.comment-list').slideDown(500);
					$(this).fadeOut(500);
			}
		});


	/* CTA to show or hide filters */
		$('a.toggleFilters').click(function (e) {
			e.preventDefault();

			$(this).toggleClass('openedFilters');
			$(this).next().slideToggle();
		});


	/* Liked article */

		$('a.like').each(function(){
			var likes = localStorage.getItem('likes');
			if(likes) {
				likes = JSON.parse(likes);
				var nid = $(this).data('nid');
				if(likes instanceof Object && likes.indexOf(nid) > -1) {
					$(this).parent().addClass('active');
				}
			}
		});

		$('a.like').click(function (e) {
			e.preventDefault();

			/* Send event for liked article to DB */

			var nid = $(this).data('nid');
			var likes = JSON.parse(localStorage.getItem('likes'));

			if(!likes || !(likes instanceof Object)) {
				likes = [];
			}

			if(likes instanceof Object && likes.indexOf(nid) > -1) {
				likes.splice(likes.indexOf(nid), 1);
				$(this).parent().removeClass('active');

				$.post('/like/action', {
					uid: $(this).data('uid'),
					nid: nid,
					like: 0
				});

			} else {
				likes.push(nid);
				$(this).parent().addClass('active');

				$.post('/like/action', {
					uid: $(this).data('uid'),
					nid: nid,
					like: 1
				});
			}

			localStorage.setItem('likes', JSON.stringify(likes));

		});


	/* Sharer */
		if ($('.sharer').length) {
			const sharer = $('.sharer');

			const minTop = $('header').height();

			let articleHeight = $('article').height();
			let articleTop = $('article').offset().top;

			$(window).resize(function () {
				articleHeight = $('article').height();
				articleTop = $('article').offset().top;
			});

			if (sharer && sharer.length) {
				setTimeout(function () { sharer.addClass('ready') }, 750);

				$(window).scroll(function (e) {
					if ($(window).width() < 420) return false;

					if ($(window).scrollTop() >= articleTop - (minTop + 50)
						&& $(window).scrollTop() <= articleTop - minTop + articleHeight + 100 - (sharer.width() / 2)) {
						// && $(window).scrollTop() <= articleTop - minTop + articleHeight - sharer.width() ) { // ==> previous method
						// Careful above, "sharer" has been rotated, so you need to actually take the width into account
						sharer.css('top', ($(window).scrollTop() - articleTop + minTop + 50) + 'px');
					}
				});
			}
		}


	/* Newsletter modal */
		function autoOpenNewsletterModal () {
			var classRegex = /page--(homepage|abonnements|offre|connexion|user)/; // Don't auto-open the modal on these pages

			if (!$('.newsletter-form').hasClass('auto-open')) sessionStorage.autoOpened = '1';

			if (
				!classRegex.test($('body').attr('class'))
				&&
				sessionStorage.autoOpened !== '1'
				&&
				!$('.modal-cookies').length) {
				setTimeout(function () { // Also added when user accepts cookies, see later in file
					$('.newsletter-pre').trigger('submit');
					sessionStorage.autoOpened = '1'; // in Timeout in case user changes page before seeing modal
				}, 15000); // 15 sec
			}
		}
		if (location.search.indexOf('action=newsletter-thanks') > -1) {
			setTimeout(function () {
				$('.newsletter-form').addClass('active');
				$('#newsletter-thanks').addClass('active');

				$('.newsletter-form .content').css('height', '450px');
				$('.newsletter-form .closer').addClass('inverted');
				if (!window.matchMedia('(max-width: 480px)').matches) {
					$('.newsletter-form .closer').css('top', '100%');
				}

				$('.closer--bg, .closer').one('click', function (e) {
					e.preventDefault();

					$('.newsletter-form').removeClass('active');

					setTimeout(() => {
						$('.newsletter-form').removeClass('auto-open')
					}, 500);
				});
			}, 500);
		}

		$('body').on('submit', '.newsletter-pre', function (e) {
			e.preventDefault();

			$('.newsletter-form').addClass('active');
			$('#newsletter-thanks').removeClass('active');

			if ($(this).find('input').val().length > 0) {
				$('.newsletter-form input[type="email"]').val($(this).find('input').val());

				$('.newsletter-form [name="firstname"]').focus();
			} else {
				$('.newsletter-form [name="email"]').focus();
			}

			$('.closer--bg, .closer').one('click', function (e) {
				e.preventDefault();

				$('.newsletter-form').removeClass('active');
				setTimeout(() => {
					$('.newsletter-form').removeClass('auto-open')
				}, 500);
			});
		});

		autoOpenNewsletterModal();


	/* Radio Fantasio */
	    $('.up-down').click(function(){ // Funk you up
    	    var radio = $(this).parents('.sticky-radio');
    	    
    	    if(!radio.hasClass('hidden')) {
        	    radio.addClass('hidden');
        	    setRadioSession({
                    hidden: true 
                });
    	    } else {
        	    radio.removeClass('hidden');
        	    setRadioSession({
                    hidden: false 
                });
    	    }
    	    
    	    //radio.toggleClass('hidden');    	    
	    });
	
		$('.radio-list a.play').click(function (e) {
			e.preventDefault();
			
			$('.sticky-radio').removeClass('hidden');
			setRadioSession({
                hidden: false 
            });

			if ($(this).parents('li').hasClass('playing')) {
				$(this).toggleClass('active');

				togglePlayer();
			} else {
				$(this).parents('li').siblings('.playing')
					.removeClass('playing')
					.find('a').removeClass('active');

				$(this).toggleClass('active');
				$(this).parents('li').addClass('playing');

				$('.sticky-radio:not(.active)').addClass('active');
				$('.sticky-radio').toggleClass('playing');

				setPlayer(this);
			}
		});

		$('.player .play').click(function (e) {
			e.preventDefault();

			$(this).toggleClass('active');
			
			$('.radio-list .playing .play').toggleClass('active');

			// toggle Play / Pause

			if( _podcasts.currentHash) {
				playToggleByHash(_podcasts.currentHash);
			}

		});

		$('.player .rewind').click(function (e) {
			e.preventDefault();
			scrubblePlayerByTime(-10);			
		});

		$('.player .forward').click(function (e) {
			e.preventDefault();
			scrubblePlayerByTime(10);
		});

		$('.progress-bar .bar').click(function(e){

			var parentOffset = $(this).offset(); 
			var relX = e.pageX - parentOffset.left;            
			var ratio = Math.round((relX / $(this).width()) *100);

			if(!isNaN(ratio)) {
				seekPlayerByRatio(ratio);   
			}
		});

		function seekPlayerByRatio(ratio) {
			if(_podcasts.hashes.hasOwnProperty(_podcasts.currentHash) ) {
				var player = _podcasts.hashes[_podcasts.currentHash];
				player.seek( Math.round( (player.duration() / 100) * ratio ) ); 
			}
		}

		function scrubblePlayerByTime(time) {
			if(_podcasts.hashes.hasOwnProperty(_podcasts.currentHash) ) {

				var player  = _podcasts.hashes[_podcasts.currentHash];
				var jump    = Math.min(Math.max(0, player.seek() + time), player.duration());
				player.seek(jump);
			}
		}
		
		function clearRadioSession() {
    		window.sessionStorage.removeItem('radio');
		}
		
		function setRadioSession(obj) {
    		
    		// Init Stored Obj
    		var storedObj = window.sessionStorage.getItem('radio');
    		if(!storedObj) {
        		storedObj = {};
    		} else {
        		storedObj = JSON.parse(storedObj);
    		}
    		
    		// Fill Obj only if not empty
    		for(var i in obj){
                if(obj[i] || obj[i] === false) storedObj[i] = obj[i];
    		}
    		
    		window.sessionStorage.setItem('radio', JSON.stringify(storedObj));
    		
    		return storedObj;
		}

		function playToggleByHash(hash) {
			clearInterval(_podcasts.loop);
			
			if(undefined == config) config = {};
			
			for(var h in _podcasts.hashes) {
				if(h !== hash) {
					_podcasts.hashes[h].stop();
				}
			}

			if(_podcasts.hashes.hasOwnProperty(hash) ) {
				var player = _podcasts.hashes[hash];
                
				if(player.playing()) {

					player.pause();
					$('.radio-list .playing .play').removeClass('active');
					$('.sticky-radio .player .play').removeClass('active');
					
					clearRadioSession();

				} else {
                    
                    var initConfig = {
                            file: player._src,
                            hash: hash
                    };

                    var parentEl = $('a[data-hash=' + hash + ']').parents('li.playing');
                    if(parentEl.length > 0){
                       initConfig.header    = parentEl.find('.mention-sup').html();
                       initConfig.title     =  parentEl.find('.title').html();
                    }
                    
                    var config = setRadioSession(initConfig);
                    setPlayerDatas( config.header, config.title );

					player.on('play', function () {
						$('.sticky-radio')
							.find('.time--total')
							.text(formatTime(player.duration()));
                        
                        let picture = null;
                        if($('.radio-list .playing .img--container').length > 0 ){
                            picture = $('.radio-list .playing .img--container').html().trim();
                        }
                        
                        var config = setRadioSession({
                            picture:picture 
                        });
                        
                        var currentPic = $('.sticky-radio .img--container').html();
                        if(currentPic != config.picture) {
						    $('.sticky-radio .img--container')
							    .html(config.picture);
                        }
					});
					
					player.on('end', function () {
    				    clearRadioSession();
					});
					
					player.on('playerror', function(e){
    					$('.sticky-radio').removeClass('active');
                        $('.sticky-radio').removeClass('playing');
                        $('.sticky-radio').removeClass('hidden');                        
					});

					player.play();
					if(config.hasOwnProperty('seek')) {
    					    player.seek(config.seek);
    				}
    									
					$('.radio-list .playing .play').addClass('active');
					$('.sticky-radio .player .play').addClass('active');
					
					$('.sticky-radio')
						.find('.time--total')
						.text(formatTime(player.seek()));

					_podcasts.loop = setInterval(function(){

						var ratio = Math.round((player.seek() / player.duration()) *100);
						if(!isNaN(ratio)) {
							$('.progress-bar .bar span').css('width', ratio + '%');
							$('.sticky-radio').find('.time--current')
								.text(formatTime(player.seek()));
								
                            setRadioSession({
                                seek: player.seek()
                            });
						}

					}, 1000);
				}
			}
		}

		function setPlayerDatas(header, title) {
			$('.sticky-radio').find('.mention-sup')
				.html(header);

			$('.sticky-radio').find('.title')
				.html(title);
		}

		function setPlayer (el) {
			if ($(el)[0].tagName != 'LI') el = $(el).parents('li');
			else el = el = $(el);

			const player = $('.sticky-radio');

			let mp3 = $(el).find('a[data-file]').data('file');
			let hash = $(el).find('a[data-file]').data('hash');

			if(! _podcasts.hashes.hasOwnProperty(hash) ) {
				_podcasts.hashes[hash] = new Howl({
					src: [mp3],
					html5: true // This activates HTML5 audio, which loads audio files for what's necessary only, not full file before playing (which can be heavy)
				}); 
			}

			_podcasts.currentHash = hash;
			playToggleByHash(hash);

			/* setTimeout(function () {
				player.find('.img-container')
					.html(el.find('.img-container').html());

				player.find('.mention-sup')
					.html(el.find('.mention-sup').html());

				player.find('.title')
					.html(el.find('.title').html());

				player.find('.play')
					.addClass('active');

				const audioLength = Math.round(Math.random() * 1.2 * 60 * 60); // Max 2 hours just for this case

				player.find('.time--total')
					.text(formatTime(audioLength));

			}, Math.random() * 4000); */

		}

		function formatTime (time) {
			time = parseInt(time) || 0;

			const s = time % 60;
			const m = Math.floor(time / 60) % 60;
			const h = Math.floor(time / 60 / 60);

			const str = {};

			str.s = s >= 10 ? s : '0' + s;
			str.m = m >= 10 ? m : '0' + m;
			str.h = h >= 10 ? h : '0' + h;

			return (
				(parseInt(str.h) > 0 ? str.h + ':' : '') + 
				(str.m + ':') +
				str.s
			)
		}

		function togglePlayer () {
			const player = $('.sticky-radio');

			player.toggleClass('playing');
			player.find('.play').toggleClass('active');

			playToggleByHash(_podcasts.currentHash);

			// if (audio.isPlaying()) audio.pause();
			// else audio.play();
		}
		
		// Replay currently playing audio file
		
		if(window.sessionStorage.getItem('radio')) {
    	    
    	    let radioPlaying = JSON.parse(window.sessionStorage.getItem('radio'));
    	    if(radioPlaying.hasOwnProperty('hash')) {
        	    
                _podcasts.hashes[radioPlaying.hash] = new Howl({
    			    src: [radioPlaying.file],
    				html5: true,
    				autoplay: true
                }); 
    				
    			_podcasts.currentHash = radioPlaying.hash;
    			playToggleByHash(radioPlaying.hash);
    			
    			
    			$('.sticky-radio').addClass('active');
                $('.sticky-radio').toggleClass('playing');
                
                console.log(radioPlaying.hidden);
                if(radioPlaying.hasOwnProperty('hidden') && radioPlaying.hidden) {
                    $('.sticky-radio').addClass('hidden');
                }                
            }		
		}


	/* Toggle hovering class when hovering LI > A elements */
		/*$('li.cell a').mouseenter(function () {
			$(this).parents('li').addClass('hovering');
		});
		$('li.cell a').mouseleave(function () {
			$(this).parents('li').removeClass('hovering');
		});*/


	/* Contest forms and alls */
		/*$('.contest-form form').each(function () {
			if ($(this).hasClass('disabled')) $(this).find('input, textarea, select').attr('disabled', '');
		});*/

		$('[type="radio"]').change(function () {
			$(this).parents('.question').addClass('answered');
		});

		$('.character-count').each(function () {
			const counter = $(this);
			const text = counter.text().replace(/[0-9]+/, '') + ' ';
				// L'espace à la fin doit rester pour un futur replace()
			const el = counter.parent().find('textarea, input');

			const min = el.attr('minlength') || el.attr('maxlength');

			if(min) {
				el.keyup(function () {
					const l = $(this).val().length;

					if (min - l <= 0) {
						counter.addClass('done');
					} else if (min - l == 1) {
						counter.text((min - l) + text.replace(/s\s/g, ' '));
						counter.removeClass('done');
					} else {
						counter.removeClass('done');
						counter.text((min - l) + text);
					}
				});			
			}
		});

		$('.contest-form .cta[name="next"]').on('click', function (e) {
			e.preventDefault();

			console.log($(this), firstPartValid($(this).parent()));

			if (firstPartValid($(this).parent())) {
				$(this).parent().css('height', $(this).parent().height());
				setTimeout(() => {
					$(this).parent().css('height', 0);
				},10);

				setTimeout(() => { $(this).parent().next().slideDown(500) }, 250);
			}
		});

		function firstPartValid (parent) {
			// parent is jQuery
			parent.find('.question').removeClass('error');

			return Array.prototype.every.call(
				parent.find('.question').find('input, select, textarea'),
				(a) => $(a).is(':valid') ?
					true :
					($(a).parents('.question').addClass('error'), false)
			);
		}


	/* In register page, when Password is focused out, remove the suggestions block */
		$('[id*="pass1"]').on('blur', function () {
			$('.password-suggestions').hide();
		});
		$('[id*="pass1"]').on('focus', function () {
			if ($('.password-suggestions ul li').length
				&&
				$('.password-suggestions ul li:first').text().length) $('.password-suggestions').show();
		});


	/* On profile page, preview the selected profile picture */
		/*$('div.form-item-user-picture-0 input').on('drop', function (e) {
			const file = e.dataTransfer.files[0];
			const reader = new FileReader();

			reader.readAsDataURL(file);
			reader.addEventListener('loadend', () => {
				const img = $(this).parent().find('img')[0];
				img.src = reader.result;
			});
		});*/


	/* In Search page, if text tapped, toggle content */
		$('.hasResults .content h3 + p').on('touchstart', function () {
			let moved = false;
			setTimeout(function () { moved = true }, 300); // If finger is kept pressed, consider it as moving

			$(this).one('touchmove', function () { moved = true }); // If finger moves (drag), consider it as moving

			$(this).one('touchend', function () {
				if (!moved) $(this).toggleClass('show-content');
			});
		});


	/* Image, iframe and embed wrapper in Wysiwyg content */
		const w = $('.wysiwyg');
		if (w && w.length) {
			w.find('img, iframe, embed').each(function () {
				if (!$(this).parents('.wysiwyg-img')[0] && !$(this).parents('.wysiwyg-video')[0]) {
					$(this).wrap('<span class="wysiwyg-img"></span>');
				}
			});
		}


	/* Footer scripts */
		$('.footer-links .category > a').on('click', function (e) {
			if (window.matchMedia('(hover: none) and (max-width: 768px)').matches) {
				e.preventDefault();
				$(this).parent().toggleClass('opened');
				$(this).next('ul').slideToggle(500);
			}
		});


	/* Temporary fix for outer links in footer */
		$('.footer-links a').each(function () {
			if (this.href.indexOf(location.host) == -1) $(this).attr('target', '_blank');
		});


	/* Offer page class addition after DOM loaded (for price-promo) */
		/*$(document).ready(() => {
			if (!$('body').hasClass('page--abonnements') && !$('body').hasClass('page--offre')) return;

			if ($('.offer-promo').length) {
				setTimeout(() => { $('.offer').parent().addClass('contains-promo') }, 250);
			}
		});*/

	/* Offer carousel for mobile */



	/* Cookies modal */
		(() => {
			const modal = $('.modal-cookies');

			if (!$('.modal-cookies').length) return;

			const btn = modal.find('.accept-cookies');
			const closeSettings = modal.find('.cookies-settings-close');
			const settings = modal.find('.modify-cookies');

			const list = modal.find('.cookies-settings');

			settings.add(closeSettings).on('click', function (e) {
				e.preventDefault();

				/*modal.find('.content p').slideToggle(750); // Method from ADJ

				list.toggleClass('active');
				list.slideToggle(750);*/

				modal.toggleClass('show-settings');

				setTimeout(function () {
					modal.find('.container').toggleClass('overflow-hidden');
					modal.find('.modify-cookies').toggleClass('cta-mono');
					if (modal.find('.modify-cookies').attr('data-icon') == 'plus--white') {
						modal.find('.modify-cookies').attr('data-icon', 'plus--red');
					} else {
						modal.find('.modify-cookies').attr('data-icon', 'plus--white');
					}
				}, 350);

				list.slideToggle(750).prev().slideToggle(750);

				$(this).blur();
			});


			btn.on('click', function (e) {
				e.preventDefault();

				const data = {
					anontracking: /* list.find('.anontracking-box').is(':checked')*/ true,
					tracking: list.find('.tracking-box').is(':checked'),
					remarketing: list.find('.remarketing-box').is(':checked'),
					profiling: list.find('.profiling-box').is(':checked')
				}

				Cookies.set('adjt', btoa(JSON.stringify(data)), {expires: 180});

				modal.addClass('close');
				setTimeout(() => modal.remove(), 1000);

				for (let key in data) {
					const el = $('script[data-' + key + ']');

					el.each(function () {
						if (!data[key]) {
							$(this).remove();
							return false;
						}

						const js = document.createElement('script');
						const attrs = this.attributes;

						for (let i = 0; i < attrs.length; i++) {
							if (attrs[i].name == 'data-' + key) continue;
							if (attrs[i].name == 'type') continue;
							js.setAttribute(attrs[i].name, attrs[i].value);
						}

						js.removeAttribute('data-' + key);

						if (js.src.length) document.body.insertAdjacentElement('beforeend', js);

						if (!js.src.length) eval(this.innerHTML);

						$(this).remove();
					});
				}

				autoOpenNewsletterModal();
			});
		})();
});

// Optimize
(function () {
	// if (sessionStorage.showupShown && sessionStorage.showupShown == 1) return;

	setTimeout(function () {
		$('.menu, .showup').addClass('show-ab');

		setTimeout(function () {
			$('.menu, .showup').removeClass('show-ab'); // removing just because more clean
			sessionStorage.setItem('showupShown', 1);
		}, 3000); // 3s is the animation duration
	}, 500);

    /* Annonce */

    /*setTimeout(function () {
        if (!('view_pop' in localStorage)) {
            createPop();
            localStorage.setItem('view_pop', 1);
        } else {
            var views_pop = Number(localStorage.getItem('view_pop'));

            if (!views_pop) {
                var nb_pop_seen = 0;
            } else {
                var nb_pop_seen = views_pop;
            }

            if (views_pop < 3) {
                localStorage.setItem('view_pop', nb_pop_seen + 1);
                createPop();
            }
        }

        function createPop() {
            let popup = document.createElement('div');
            popup.classList.add('pop', 'pop-b-r');

            let popup_content = document.createElement('div');
            popup_content.classList.add('pop__content');
            popup_content.innerHTML = 'Nous rencontrons actuellement des difficultés techniques sur nos adresses mails.<br><br>Pour toutes questions relatives aux abonnements merci de vous adresser à <a href="mailto:spirou@ediis.fr">spirou@ediis.fr</a>&nbsp;;<br>pour toutes autres questions contactez&nbsp;: <a href="mailto:abonnespirou@gmail.com">abonnespirou@gmail.com</a>.<br><br>De plus, en ces circonstances exceptionnelles nous ne pourrons assurer le suivi des concours de façon optimale&nbsp;.<br><br>À très vite pour des cadeaux encore plus beaux.';

            let popup_close = document.createElement('span');
            popup_close.classList.add('pop__close');
            popup_close.innerHTML = '<span></span><span></span>';
            popup_close.addEventListener('click', (e) => {
                popup.classList.remove('show');
                setTimeout(function () {
                    popup.remove();
                }, 251);
            });

            popup.appendChild(popup_content);
            popup.appendChild(popup_close);
            document.body.appendChild(popup);

            setTimeout(function () {
                popup.classList.add('show');
            }, 1501);
        }
    }, 1500);*/
})();